import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UserFeedback } from './interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';

const baseUrl = '/api/guidance/feedbacks';

export const useShowUserFeedback = () => {
  const result = useQuery<UserFeedback>({
    queryFn: async () => await falconClient.get(baseUrl),
    queryKey: [clientKeys.useUserFeedback],
  });

  return {
    userFeedback: result.data,
    ...result,
  };
};

export const useCreateUserFeedback = () => {
  const queryClient = useQueryClient();
  return useMutation<UserFeedback, Error, string>({
    mutationFn: async (data): Promise<UserFeedback> =>
      await falconClient.post(baseUrl, { content: data }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: [clientKeys.useUserFeedback],
      });

      queryClient.resetQueries({
        queryKey: [clientKeys.useUserPrioritySkillSetsIndex],
      });
    },
  });
};

export const useDeleteUserFeedback = () => {
  const queryClient = useQueryClient();
  return useMutation<void, Error>({
    mutationFn: async (): Promise<void> => {
      await falconClient.delete(baseUrl);
    },
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: [clientKeys.useUserFeedback],
      });
      queryClient.resetQueries({
        queryKey: [clientKeys.useUserPrioritySkillSetsIndex],
      });
    },
  });
};
